module.exports = __webpack_public_path__ + "img/more_info.d54db9e7.svg";